// Entity bookkeeping (§29.3, re-exported by items.ts). Free of map/mode imports so map modules can
// spawn their props without an import cycle. A removed entity object gets id 0 (ids live in
// [1, MAX_ENT_ID]), so a step that iterates a copy of the entity list can tell it is gone.
import { MAX_ENT_ID } from '../constants';
import type { EK } from '../ids';
import type { Entity, World } from '../types';

/** Appends a new entity with the next free id in [1, MAX_ENT_ID] (ids wrap and skip live ones). */
export function spawnEntity(w: World, kind: EK, owner: number, x: number, y: number, z: number): Entity {
  let id = w.nextEntId;
  while (findEntity(w, id)) id = id >= MAX_ENT_ID ? 1 : id + 1;
  w.nextEntId = id >= MAX_ENT_ID ? 1 : id + 1;
  const e: Entity = { id, kind, owner, pos: { x, y }, vel: { x: 0, y: 0 }, z, vz: 0, t: 0, timer: 0, data: 0, data2: 0 };
  w.ents.push(e);
  return e;
}

export function removeEntity(w: World, id: number): void {
  const i = w.ents.findIndex((e) => e.id === id);
  if (i >= 0) removeEntityAt(w, i);
}

/** Removes the entity at array index `i` and marks the object as removed (id 0). */
export function removeEntityAt(w: World, i: number): void {
  const e = w.ents[i];
  w.ents.splice(i, 1);
  e.id = 0;
}

/** True once `e` has been removed from its world. */
export function isRemoved(e: Entity): boolean {
  return e.id === 0;
}

export function findEntity(w: World, id: number): Entity | undefined {
  return w.ents.find((e) => e.id === id);
}
